import { arrayOf, string, func } from 'prop-types'
import React, { Fragment } from 'react'
import HrbTranslate from '../../../components/language/HrbTranslate'
import lang from '../../../components/language/services/Lang'
import ScrollingListBox from '../../../components/library/common/ScrollingListBox'
import AvailableCheckboxItem from './AvailableCheckboxItem'

const AvailableProductsListBox = props => {

    const { availableProducts, checkedProducts, onCheckedProductsChanged } = props

    const handleProductChecked = (product, checked) => {
        let selected = checkedProducts ? [...checkedProducts] : []

        if (checked === true) {
            // add product code to selection list
            if (selected.indexOf(product) === -1) {
                selected.push(product);
            }
        } else {
            // remove product code from selection list
            let index = selected.indexOf(product)
            if (index !== -1) {
                selected.splice(index, 1)
            }
        }

        // let somebody know!
        if (onCheckedProductsChanged) {
            onCheckedProductsChanged(selected)
        }
    }

    return (
        <div className='column is-5'>
            <em className='p2 mb-3'><HrbTranslate text='AssociateOfficesModal.AvailableProducts' /></em>
            <ScrollingListBox elementId='list-available-products' className='product-list'>
                {!availableProducts &&
                    <Fragment>
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                    </Fragment>
                }
                {availableProducts && availableProducts.map(o =>
                    <AvailableCheckboxItem
                        key={o}
                        id={o}
                        label={lang.getCurrentValue(`AssociatesPage.ProductAssignments.${o}`)}
                        checked={checkedProducts.includes(o)}
                        onCheckChanged={handleProductChecked} />
                )}
            </ScrollingListBox>
        </div>
    )
}

AvailableProductsListBox.propTypes = {
    availableProducts: arrayOf(string),
    checkedProducts: arrayOf(string),
    onCheckedProductsChanged: func
}

export default AvailableProductsListBox